(function ($) {
	$(document).gp_ready(function () {
		// Open cart after add-to-cart
		$('[data-form-id="customer-contact-info"], [data-form-id="customer-shipping-address"], [data-form-id="customer-billing-address"], [data-form-id="customer-password-change"]')
			.off('submit_success')
			.on('submit_success', function (e, form_id) {
				$(document).trigger('close_modal')
			})
	})
})(jQuery);
